import React from "react";
import RPagination from "react-responsive-pagination";
import {useTranslation} from "../../../hooks/useTranslation";

const Pagination = ({currentPage, totalPages, handlePageChange, maxWidth}) => {
    const {t} = useTranslation();
    const borderRadius = "5px";

    return (
        <React.Fragment>
            <style dangerouslySetInnerHTML={{
                    __html: `
                        .page-item:first-child .page-link {
                          border-top-left-radius: 0;
                          border-bottom-left-radius: 0;
                        }
                        .page-item:last-child .page-link {
                          border-top-right-radius: 0;
                          border-bottom-right-radius: 0;
                        }
                      `,
                }}
            />
            <div className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{
                cursor: "pointer",
                height: "min-content",
                marginRight: "-1px"
            }}>
                <button
                    onClick={() => handlePageChange(1)}
                    className={"page-link"}
                    style={{borderTopLeftRadius: borderRadius, borderBottomLeftRadius: borderRadius}}
                >
                    {t("General.firstPage")}
                </button>
            </div>

            <RPagination
                current={currentPage}
                total={totalPages}
                onPageChange={(e) => handlePageChange(e)}
                previousLabel={t("General.previousPage")}
                nextLabel={t("General.nextPage")}
                maxWidth={Number(maxWidth)}
            />

            <div className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{
                cursor: "pointer",
                height: "min-content"
            }}>
                <button
                    onClick={() => handlePageChange(totalPages)}
                    className={"page-link"}
                    style={{borderTopRightRadius: borderRadius, borderBottomRightRadius: borderRadius}}
                >
                    {t("General.lastPage")}
                </button>
            </div>
        </React.Fragment>
    )
}

export default Pagination;